const notes = {
  title: 'כותרת',
  details: 'פרטים',
  content: 'תוכן',
  showForm: 'הערה חדשה',
  to: { label: 'אל', validation: 'אל נדרש' },
  addNote: 'הוסף',
  cancel: 'בטל',
  save: 'שמור',
  createdAt: 'Created At: ',
  createdBy: 'Created By: ',
  noteType: 'Note Type ',
  typeNewNote: 'הקלד הערה חדשה...',
  dropDownIcons: {
    pinToTop: 'נעץ לראש',
    unpinFromTop: 'הסר נעיצה',
    EditUpdate: 'ערוך עדכון',
    DeleteUpdate: 'מחק עדכון לכולם',
  },
  edit: {
    toast: {
      error: {
        delete: 'ההערה לא הוסרה',
        add: 'ההערה לא נוספה',
        update: 'ההערה לא עודכנה',
        pin: 'ההערה לא ננעצה לראש',
        unpin: 'ההערה לא הוסרה מהנעיצה',
      },
    },
  },
};

export default notes;
